// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
.loadingIndicatorCircle {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.loadingIndicatorCircle:before {
  content: '';
  display: block;
  margin: 0 auto;
  width: 15%;
  height: 15%;
  background-color: #999;
  border-radius: 100%;
  animation: circleFadeDelay 1.2s infinite ease-in-out both;
}
.loadingIndicatorCircle.circle-1 {
  -webkit-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  transform: rotate(30deg);
}
.loadingIndicatorCircle.circle-1:before {
  -webkit-animation-delay: -1.1s;
  animation-delay: -1.1s;
}
.loadingIndicatorCircle.circle-2 {
  -webkit-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  transform: rotate(60deg);
}
.loadingIndicatorCircle.circle-2:before {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}
.loadingIndicatorCircle.circle-3 {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}
.loadingIndicatorCircle.circle-3:before {
  -webkit-animation-delay: -0.9s;
  animation-delay: -0.9s;
}
.loadingIndicatorCircle.circle-4 {
  -webkit-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  transform: rotate(120deg);
}
.loadingIndicatorCircle.circle-4:before {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
}
.loadingIndicatorCircle.circle-5 {
  -webkit-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  transform: rotate(150deg);
}
.loadingIndicatorCircle.circle-5:before {
  -webkit-animation-delay: -0.7s;
  animation-delay: -0.7s;
}
.loadingIndicatorCircle.circle-6 {
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}
.loadingIndicatorCircle.circle-6:before {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;
}
.loadingIndicatorCircle.circle-7 {
  -webkit-transform: rotate(210deg);
  -ms-transform: rotate(210deg);
  transform: rotate(210deg);
}
.loadingIndicatorCircle.circle-7:before {
  -webkit-animation-delay: -0.5s;
  animation-delay: -0.5s;
}
.loadingIndicatorCircle.circle-8 {
  -webkit-transform: rotate(240deg);
  -ms-transform: rotate(240deg);
  transform: rotate(240deg);
}
.loadingIndicatorCircle.circle-8:before {
  -webkit-animation-delay: -0.4s;
  animation-delay: -0.4s;
}
.loadingIndicatorCircle.circle-9 {
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  transform: rotate(270deg);
}
.loadingIndicatorCircle.circle-9:before {
  -webkit-animation-delay: -0.3s;
  animation-delay: -0.3s;
}
.loadingIndicatorCircle.circle-10 {
  -webkit-transform: rotate(300deg);
  -ms-transform: rotate(300deg);
  transform: rotate(300deg);
}
.loadingIndicatorCircle.circle-10:before {
  -webkit-animation-delay: -0.2s;
  animation-delay: -0.2s;
}
.loadingIndicatorCircle.circle-11 {
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
  transform: rotate(330deg);
}
.loadingIndicatorCircle.circle-11:before {
  -webkit-animation-delay: -0.1s;
  animation-delay: -0.1s;
}
@keyframes circleFadeDelay {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}
`, "",{"version":3,"sources":["webpack://./app/components/LoadingIndicator/circle.less"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C,sBAAsB;AACtB,6FAA6F;AAD7F;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;AAGF;AADE;EACE,WAAA;EACA,cAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,yDAAA;AAGJ;AAAE;EACE,gCAAA;EACA,4BAAA;EACA,wBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,gCAAA;EACA,4BAAA;EACA,wBAAA;AAEJ;AADI;EACE,4BAAA;EACA,oBAAA;AAGN;AAAE;EACE,gCAAA;EACA,4BAAA;EACA,wBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAAE;EACE,iCAAA;EACA,6BAAA;EACA,yBAAA;AAEJ;AADI;EACE,8BAAA;EACA,sBAAA;AAGN;AAEA;EACE;;;IAGE,UAAA;EAAF;EAGA;IACE,UAAA;EADF;AACF","sourcesContent":["@import \"~antd/lib/style/color/colorPalette.less\";\n.loadingIndicatorCircle {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n\n  &:before {\n    content: '';\n    display: block;\n    margin: 0 auto;\n    width: 15%;\n    height: 15%;\n    background-color: #999;\n    border-radius: 100%;\n    animation: circleFadeDelay 1.2s infinite ease-in-out both;\n  }\n\n  &.circle-1 {\n    -webkit-transform: rotate(30deg);\n    -ms-transform: rotate(30deg);\n    transform: rotate(30deg);\n    &:before {\n      -webkit-animation-delay: -1.1s;\n      animation-delay: -1.1s;\n    }\n  }\n  &.circle-2 {\n    -webkit-transform: rotate(60deg);\n    -ms-transform: rotate(60deg);\n    transform: rotate(60deg);\n    &:before {\n      -webkit-animation-delay: -1s;\n      animation-delay: -1s;\n    }\n  }\n  &.circle-3 {\n    -webkit-transform: rotate(90deg);\n    -ms-transform: rotate(90deg);\n    transform: rotate(90deg);\n    &:before {\n      -webkit-animation-delay: -0.9s;\n      animation-delay: -0.9s;\n    }\n  }\n  &.circle-4 {\n    -webkit-transform: rotate(120deg);\n    -ms-transform: rotate(120deg);\n    transform: rotate(120deg);\n    &:before {\n      -webkit-animation-delay: -0.8s;\n      animation-delay: -0.8s;\n    }\n  }\n  &.circle-5 {\n    -webkit-transform: rotate(150deg);\n    -ms-transform: rotate(150deg);\n    transform: rotate(150deg);\n    &:before {\n      -webkit-animation-delay: -0.7s;\n      animation-delay: -0.7s;\n    }\n  }\n  &.circle-6 {\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n    &:before {\n      -webkit-animation-delay: -0.6s;\n      animation-delay: -0.6s;\n    }\n  }\n  &.circle-7 {\n    -webkit-transform: rotate(210deg);\n    -ms-transform: rotate(210deg);\n    transform: rotate(210deg);\n    &:before {\n      -webkit-animation-delay: -0.5s;\n      animation-delay: -0.5s;\n    }\n  }\n  &.circle-8 {\n    -webkit-transform: rotate(240deg);\n    -ms-transform: rotate(240deg);\n    transform: rotate(240deg);\n    &:before {\n      -webkit-animation-delay: -0.4s;\n      animation-delay: -0.4s;\n    }\n  }\n  &.circle-9 {\n    -webkit-transform: rotate(270deg);\n    -ms-transform: rotate(270deg);\n    transform: rotate(270deg);\n    &:before {\n      -webkit-animation-delay: -0.3s;\n      animation-delay: -0.3s;\n    }\n  }\n  &.circle-10 {\n    -webkit-transform: rotate(300deg);\n    -ms-transform: rotate(300deg);\n    transform: rotate(300deg);\n    &:before {\n      -webkit-animation-delay: -0.2s;\n      animation-delay: -0.2s;\n    }\n  }\n  &.circle-11 {\n    -webkit-transform: rotate(330deg);\n    -ms-transform: rotate(330deg);\n    transform: rotate(330deg);\n    &:before {\n      -webkit-animation-delay: -0.1s;\n      animation-delay: -0.1s;\n    }\n  }\n}\n\n@keyframes circleFadeDelay {\n  0%,\n  39%,\n  100% {\n    opacity: 0;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
